import { z } from 'zod';

export const shippingAddress = z.object({
  line1: z.string(),
  line2: z.string().nullable(),
  city: z.string(),
  state: z.string().optional().nullable(),
  country: z.string(),
  postalCode: z.string(),
  phone: z.string().nullable().optional(),
  name: z.string(),
  email: z.string().optional(),
});
export type ShippingAddress = z.infer<typeof shippingAddress>;
